module.exports = __webpack_public_path__ + "img/new-step13.6d8a4b6d.jpg";